import { render, staticRenderFns } from "./DeliveryZone.vue?vue&type=template&id=97db4770&scoped=true&"
import script from "./DeliveryZone.vue?vue&type=script&lang=js&"
export * from "./DeliveryZone.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryZone.vue?vue&type=style&index=0&id=97db4770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97db4770",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VForm,VRow})
